document.addEventListener("click", function (e) {
  // click on button OR grid item
  const gridItem = e.target.closest(".grid-item");
  if (!gridItem) return;

  const btn = gridItem.querySelector(".learn-more");

  // prevent double trigger when clicking button
  if (e.target.closest(".learn-more")) {
    e.stopPropagation();
  }

  // toggle classes
  gridItem.classList.toggle("active");
  btn.classList.toggle("close");

  // update text
  btn.textContent = btn.classList.contains("close")
    ? "Close"
    : "Learn More";
});
 

document.addEventListener("DOMContentLoaded", () => {
  const items = document.querySelectorAll(".faqs-item");

  items.forEach((item) => {
    const question = item.querySelector(".faq-question");
    const answer = item.querySelector(".faq-answer");

    // open first by default
    if (item.classList.contains("active")) {
      answer.style.maxHeight = answer.scrollHeight + "px";
    }

    question.addEventListener("click", () => {
      const isActive = item.classList.contains("active");

      // close all
      items.forEach(i => {
        i.classList.remove("active");
        i.querySelector(".faq-answer").style.maxHeight = null;
      });

      // open current
      if (!isActive) {
        item.classList.add("active");
        answer.style.maxHeight = answer.scrollHeight + "px";
      }
    });
  });
});

document.addEventListener('click', function(e) {
  const trigger = e.target.closest('.rating-wrapper-scroller');

  if (trigger) {
    e.preventDefault();

    const target = document.querySelector('.animation--section-introduction');

    if (target) {

      // change this value based on your header height
      const headerOffset = 120;

      const elementPosition = target.getBoundingClientRect().top + window.pageYOffset;

      const offsetPosition = elementPosition - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  }
});
document.addEventListener('DOMContentLoaded', function () {

  // Mobile only
  if (window.innerWidth > 768) return;

  const addToCartBtn = document.querySelector('.sticky-atc-bar__button .product-form__cart-submit');
  const addToCartText = addToCartBtn?.querySelector('[data-add-to-cart-text]');

  const colorWrapper = document.querySelector('.product__color-swatches');
  const sizeWrapper =
  document.querySelector('.product__size-swatches') ||
  document.querySelector('.product__color-chips');

  // Details section
  const detailsSection = document.querySelector('.sticky-atc-bar__details');

  if (!addToCartBtn || !addToCartText) return;

  // Detect options
const hasColorOption =
  colorWrapper &&
  colorWrapper.querySelectorAll('button').length > 0;

const hasSizeOption =
  sizeWrapper &&
  sizeWrapper.querySelectorAll('button').length > 0;
console.log(hasColorOption);
console.log('11111111111111')
  // Change button text
  if (hasColorOption) {

    addToCartText.innerText = 'Select a colour';

    // Hide details section
    if (detailsSection) {
      detailsSection.style.display = 'none';
    }

  } else if (hasSizeOption) {

    addToCartText.innerText = 'Choose your size';

    // Hide details section
    if (detailsSection) {
      detailsSection.style.display = 'none';
    }
  }

  // Scroll functionality
  addToCartBtn.addEventListener('click', function (e) {

    if (hasColorOption || hasSizeOption) {
      e.preventDefault();
    }

    const scrollTarget = hasColorOption
      ? colorWrapper
      : sizeWrapper;

    if (scrollTarget) {

      const headerOffset = 140;

      const elementPosition =
        scrollTarget.getBoundingClientRect().top + window.pageYOffset;

      const offsetPosition = elementPosition - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  });

});
document.addEventListener('click', function(e) {

  if (window.innerWidth > 767) return;

  const swatch = e.target.closest('.product__color-swatch');

  if (!swatch) return;

  setTimeout(() => {

    const target = document.querySelector('.product__media-container.below-mobile');

    if (target) {

      const headerOffset = 120;

      const elementPosition =
        target.getBoundingClientRect().top + window.pageYOffset;

      const offsetPosition = elementPosition - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });

    }

  }, 300);

});
window.addEventListener('load', function () {

  let clicked = false;

  const interval = setInterval(() => {

    const btn = document.querySelector('[data-more-media]');

    if (
      btn &&
      !clicked &&
      btn.textContent.trim().toLowerCase().includes('more')
    ) {

      clicked = true;
      btn.click();

      clearInterval(interval);
    }

  }, 1000);

});


document.addEventListener('click', function (e) {

  const swatch = e.target.closest('.product__color-swatch');

  if (swatch) {

    const interval = setInterval(() => {

      const btn = document.querySelector('[data-more-media]');


      if (btn) {
        
        const text = btn.textContent.trim().toLowerCase();

        if (text.includes('more')) {
          
          btn.click();
        }

        clearInterval(interval);
      }

    }, 3000);

  }

});
document.addEventListener('DOMContentLoaded', function () {

  if (window.innerWidth <= 768) {

    document.querySelectorAll('.accordion__inner').forEach(function(item) {

      item.setAttribute('data-open', 'false');

      const button = item.querySelector('.accordion__label');
      const content = item.querySelector('.accordion__content');

      if (button) {
        button.setAttribute('aria-expanded', 'false');
      }

      if (content) {
        content.setAttribute('aria-hidden', 'true');
        content.style.display = 'none';
      }

    });

  }

});


document.addEventListener('DOMContentLoaded', function () {
    const mainATC = document.querySelector('button.product-form__cart-submit');
    const stickyBar = document.querySelector('.sticky-atc-bar');
    const header = document.querySelector('.header-wrapper') || document.querySelector('header');

    if (!mainATC || !stickyBar) return;

    stickyBar.classList.add('hidden');
    stickyBar.style.display = 'none';

    let observer;
    let isFirstCallback = true; 

    function setStickyVisible(visible) {
        if (visible) {
            stickyBar.classList.remove('hidden');
            stickyBar.style.display = '';
            document.querySelector('.rp-micro-app-dummy-icon-container')?.style.setProperty('display', 'none', 'important');
            document.querySelector('#alia-root-224125')?.style.setProperty('display', 'none', 'important');
        } else {
            stickyBar.classList.add('hidden');
            stickyBar.style.display = 'none';
            document.querySelector('.rp-micro-app-dummy-icon-container')?.style.setProperty('display', 'block', 'important');
            document.querySelector('#alia-root-224125')?.style.setProperty('display', 'block', 'important');
        }
    }

    function initObserver() {
        if (observer) observer.disconnect();
        isFirstCallback = true; 

        const headerHeight = header ? header.offsetHeight : 60;

        observer = new IntersectionObserver(
            function (entries) {
                // Always ignore the very first callback — it's just the initial state fire
                if (isFirstCallback) {
                    isFirstCallback = false;
                    return;
                }

                entries.forEach(function (entry) {
                    const rect = mainATC.getBoundingClientRect();

                    if (!entry.isIntersecting && rect.top < headerHeight) {
                        setStickyVisible(true);
                    } else {
                        setStickyVisible(false);
                    }
                });
            },
            {
                threshold: 0,
                rootMargin: `-${headerHeight}px 0px 0px 0px`
            }
        );

        observer.observe(mainATC);
    }

    initObserver();

    let resizeTimer;
    window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(initObserver, 200);
    });
});

  function updatePopupPosition() {

  const stickyBar = document.querySelector('.sticky-atc-bar');
  const popup = document.querySelector('[id^="alia-popup-root-"]');

  if (!stickyBar || !popup) return;

  const stickyVisible =
    window.getComputedStyle(stickyBar).display !== 'none';

  if (stickyVisible) {
    popup.style.bottom = '90px';
  } else {
    popup.style.bottom = '20px';
  }
}

window.addEventListener('scroll', updatePopupPosition);
window.addEventListener('load', updatePopupPosition);

setTimeout(updatePopupPosition, 2000);



document.addEventListener('DOMContentLoaded', function () {
  function initVideoAutoplay() {
    var videoWrappers = document.querySelectorAll('.product__media-item[data-media-type="video"]');

    videoWrappers.forEach(function (wrapper) {
      wrapper.removeAttribute('data-has-mobile-video-modal');

      var v = wrapper.querySelector('video');
      if (!v) return;

      v.removeAttribute('data-interactive');
      v.preload = 'auto';
      v.muted = true;
      v.loop = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.setAttribute('autoplay', '');

      // Wait for Plyr to finish initialising then force play
      setTimeout(function () {
        v.play().catch(function () {});
      }, 800);
    });
  }

  // Run once on load
  initVideoAutoplay();

  // Also watch for Plyr adding plyr--paused class and override it
  var observer = new MutationObserver(function () {
    var videoWrappers = document.querySelectorAll('.product__media-item[data-media-type="video"]');
    videoWrappers.forEach(function (wrapper) {
      var v = wrapper.querySelector('video');
      if (v && v.paused) {
        v.play().catch(function () {});
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
});

window.addEventListener('scroll', function() {
    const backToTop = document.querySelector('.back-to-top');

    if (!backToTop) return;

    if (backToTop.classList.contains('visible')) {
        backToTop.style.bottom = '90px';
    } else {
        backToTop.style.bottom = '16px';
    }
});

document.addEventListener('click', function(e) {
  const swatch = e.target.closest('.dynamic-variant-button');
  if (!swatch) return;

  setTimeout(() => {
  const media = document.querySelector('.product__media-item .media');
  if (!media) return;

  let badgeWrapper = media.querySelector('.product-badges');

  if (!badgeWrapper) {
    badgeWrapper = document.createElement('div');
    badgeWrapper.className =
      'product-badges product-badges--position-top product-badges--position-left';

    media.prepend(badgeWrapper);
  }

  let badge = badgeWrapper.querySelector('.product-badge');

  if (!badge) {
    badge = document.createElement('div');
    badge.className = 'product-badge';
    badgeWrapper.appendChild(badge);
  }

  badge.textContent = 'New';
  badge.setAttribute('data-handle', 'new');

}, 3000);
});




(function() {
  function updateDesktopBadge() {
    setTimeout(function() {
      const firstMediaItem = document.querySelector('.product__media-container.above-mobile .product__media .product__media-item');
      if (!firstMediaItem) return;

      const hasNew = [...document.querySelectorAll('.dynamic-variant-button.selected .variant-tag')]
        .some(tag => tag.textContent.trim() === 'New');

      const existing = firstMediaItem.querySelector('.product-badges--injected');
      if (existing) existing.remove();

      const badgesDiv = document.createElement('div');
      badgesDiv.className =
        'product-badges product-badges--position-top product-badges--position-left product-badges--injected';

      badgesDiv.innerHTML = hasNew
        ? `<div class="product-badge product-badge--sale">Sale</div>
           <div class="product-badge" data-handle="new">New</div>`
        : `<div class="product-badge product-badge--sale">Sale</div>`;

      firstMediaItem.style.position = 'relative';
      firstMediaItem.appendChild(badgesDiv);
    }, 3000);
  }

  function updateMobileBadge() {
    setTimeout(function() {
      // Use the existing server-rendered badges container on mobile
      const badgesContainer = document.querySelector('.product__media-container.below-mobile .product-badges');
      if (!badgesContainer) return;

      const hasNew = [...document.querySelectorAll('.dynamic-variant-button.selected .variant-tag')]
        .some(tag => tag.textContent.trim() === 'New');

      // Only remove/manage OUR own injected badge — never touch data-handle="new-colours"
      const existingOwnBadge = badgesContainer.querySelector('[data-handle="new"]');
      if (existingOwnBadge) existingOwnBadge.remove();

      if (hasNew) {
        const saleBadge = badgesContainer.querySelector('.product-badge--sale');
        const newBadge = document.createElement('div');
        newBadge.className = 'product-badge';
        newBadge.setAttribute('data-handle', 'new');
        newBadge.textContent = 'New';

        if (saleBadge) {
          saleBadge.insertAdjacentElement('afterend', newBadge);
        } else {
          badgesContainer.appendChild(newBadge);
        }
      }
    }, 3000);
  }

  function updateNewBadge() {
    updateDesktopBadge();
    updateMobileBadge();
  }

  document.addEventListener('click', function(e) {
    if (e.target.closest('.dynamic-variant-button')) {
      updateNewBadge();
    }
  });

  updateNewBadge();
})();